export class WbResponseError extends Error {
    constructor(message, action) {
        super(message);
        this.action = action;
    }
}
